'use client';

import { useEffect, useState } from 'react';
import { getServiceCategories } from '@/lib/actions/service-categories';
import { CategoryList } from '@/components/admin/services/CategoryList';

export default function AdminServiceCategoriesPage() {
  const [categories, setCategories] = useState<Awaited<ReturnType<typeof getServiceCategories>>>([]);

  useEffect(() => {
    getServiceCategories().then(setCategories);
  }, []);

  return (
    <div className="space-y-6">
      <CategoryList categories={categories} />
    </div>
  );
}
